import TubCommon from "./tubCommon";

export default class TubLiner extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = "tub_liner";
    this.bottomTubId = "tub_liner";
    this.visible = true;
    this.partName = "Tub Liner";
    this.translateId = "visualizer.bathroom.shower_tub_combo.bathtub_liner";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
  }
}
